import { create } from "zustand";
import {
  addCombo,
  addNewProduct,
  deleteProduct,
  productMapping,
} from "../api_layer/api";
import { isEmpty } from "lodash";

export const useProductMappingStore = create((set) => ({
  productsData: [],
  productsLoading: false,
  addLoading: false,
  deleteLoading: false,
  error: null,
  fetchProductsData: async () => {
    try {
      if(isEmpty(productsData)){
        set({ productsLoading: true, error: null });
        const response = await productMapping();
        set({ productsData: response.data, productsLoading: false });
      }
    } catch (error) {
      set({ error: error.message, productsLoading: false });
    }
  },
  addOneProductData: async (
    payload,
    setToaster,
    fetchProductData,
    handleModalClose
  ) => {
    try {
      set({ addLoading: true, error: null });
      await addNewProduct(payload);
      setToaster("Product", "Product added successfully", "success");
      fetchProductData();
      handleModalClose();
      set({ addLoading: false });
    } catch (error) {
      handleModalClose();
      setToaster("Product", "Adding product failed", "danger");
      set({ error: error.message, addLoading: false });
    }
  },
  addComboProductData: async (
    payload,
    setToaster,
    fetchProductData,
    handleModalClose
  ) => {
    try {
      set({ addLoading: true, error: null });
      await addCombo(payload);
      setToaster("Product", "Combo added successfully", "success");
      fetchProductData();
      handleModalClose();
      set({ addLoading: false });
    } catch (error) {
      handleModalClose();
      setToaster("Combo", "Adding Combo failed", "danger");
      set({ error: error.message, addLoading: false });
    }
  },
  deleteProductData: async (id, setToaster, fetchProductsData) => {
    try {
      set({ deleteLoading: true, error: null });
      await deleteProduct(id);
      setToaster("Medicines", "Product deleted successfully", "success");
      fetchMedicinesData();
      set({ deleteLoading: false });
    } catch (error) {
      setToaster("Medicines", "Failed to delete Products", "danger");
      set({ error: error.message, deleteLoading: false });
    }
  },
}));
